import React from 'react';
import { Column } from '@tanstack/react-table';
import DefaultColumnFilter from '../datatable.columnfilter';

interface FilterSelectorProps {
    column: Column<any, unknown>;
}

export function FilterSelector({ column }: FilterSelectorProps) {
    const columnFilterValue = column.getFilterValue();
    const filter = column.columnDef.filterFn ?? {};

    // Cannot pass column to filters directly as implementation of filters expect a different structure column to react table V8
    let projectedColumn = {
        filterValue: columnFilterValue,
        preFilteredRows: null,
        setFilter: column.setFilterValue,
    };

    switch (filter) {
        case "includesString":
            return (<DefaultColumnFilter column={projectedColumn} />);
        case "select":
            //TODO Create a filter component that's able to get the full list of options from the server to use, rather than just what's available on the current page
            return <></>;
        default:
            return <></>;
    }
}
